import ProgressBar from "tds/progressBar";

export { ProgressBar };

customElements.define("tds-progress-bar", ProgressBar.CustomElementConstructor);
